import {Button} from 'components/system/button';
import React from 'react';

export function QuickFilter<T extends keyof QuestionListFilters>({
  name,
  icon,
  configKey,
  value,
  config,
  onConfigChange,
}: Props<T>) {
  const selected = config[configKey].includes(value as never); // TODO: Try to remove this hack.
  const color = selected ? 'orange' : 'greyDark';
  const handleClick = () => {
    onConfigChange({
      ...config,
      page: 0,
      [configKey]: selected ? [] : [value],
    });
  };
  return (
    <Button
      type='text'
      color={color}
      icon={React.cloneElement(icon, {color})}
      onClick={handleClick}>
      {name}
    </Button>
  );
}

type Props<T extends keyof QuestionListFilters> = {
  name: string;
  icon: JSX.Element;
  configKey: T;
  value: QuestionListFilters[T][0];
  config: QuestionListConfig;
  onConfigChange: (config: QuestionListConfig) => void;
};
